import React from 'react';
import '../StyleSheets/GraphDataItem.css';


export default class GraphDataItem extends React.Component {

    state = {
        isActive: this.props.isActive,
        isHover: false
    }

    render() {
        const { inActiveOpacity } = this.props;
        const { isActive, isHover } = this.state;

        const iaApacity = inActiveOpacity === undefined ? 0.3 : inActiveOpacity;

        return <div className="graphDataItemCont" 
                    style={{opacity: isActive || isHover ? 1 : iaApacity}}
                    onMouseEnter={ e => this.setState({isHover:true})}
                    onMouseLeave={ e => this.setState({isHover:false})}
                    onClick={ e => {
                        this.setState( {isActive: !isActive}, () => this.props.onToggle(this.state.isActive) );
                    }}
        >
            <div id="lineColor" style={{backgroundColor: this.props.color}}/>
            <div id="graphDataItemTitle">{this.props.title}</div>
        </div>
    }

}